module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/4a11a91223cda9e4d997194afb7a580a.png";